module.exports = __webpack_public_path__ + "img/generated-datacenter.a7c065bd.png";